import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";
import { UPDATE_MEMBER_PAUSE_STATUS } from "./actionTypes";

// Thunks that POST to the pause/resume endpoints and return the raw API
// payload so the caller can drive its own modal/loading/toast UX.

export const pauseSubscription = () => (dispatch) =>
  http
    .post(
      "pause_subscription",
      doObjToFormData({ token: localStorage.getItem("authToken") })
    )
    .then(({ data }) => {
      if (data?.status === 1) {
        dispatch({
          type: UPDATE_MEMBER_PAUSE_STATUS,
          payload: {
            status: 1,
            // Field name is `mem_pause_access_until` / `mem_pause_fee` on the
            // new API contract; keep the unprefixed legacy keys as fallback
            // so older API builds don't break the flow during a rolling
            // backend deploy.
            access_until:
              data.mem_pause_access_until || data.access_until || null,
            pause_fee: data.mem_pause_fee ?? data.pause_fee ?? null,
          },
        });
      }
      return data;
    });

export const resumeSubscription = () => (dispatch) =>
  http
    .post(
      "resume_subscription",
      doObjToFormData({ token: localStorage.getItem("authToken") })
    )
    .then(({ data }) => {
      if (data?.status === 1) {
        dispatch({
          type: UPDATE_MEMBER_PAUSE_STATUS,
          payload: { status: 0, access_until: null, pause_fee: null },
        });
      }
      return data;
    });
